import {
  withTranslation,
} from 'react-i18next';

import ProfileInvoicesSectionView from './ProfileInvoicesSectionView';

const TranslatedComponent = withTranslation()(ProfileInvoicesSectionView);

const Component = TranslatedComponent;

export default Component;
